// ----------------------------------------------------------------------

export function createTypography(fontFamily: string, fontSize: number) {
  const scale = fontSize / 16;
  const p2r = (value: number) => `${(value / 16) * scale}rem`;
  const rFS = ({ sm, md, lg }: { sm: number; md: number; lg: number }) => ({
    '@media (min-width:600px)': {
      fontSize: p2r(sm),
    },
    '@media (min-width:900px)': {
      fontSize: p2r(md),
    },
    '@media (min-width:1200px)': {
      fontSize: p2r(lg),
    },
  });

  return {
    fontFamily,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: {
      fontWeight: 700,
      lineHeight: 80 / 64,
      fontSize: p2r(40),
      letterSpacing: 2,
      ...rFS({ sm: 52, md: 58, lg: 64 }),
    },
    h2: {
      fontWeight: 700,
      lineHeight: 64 / 48,
      fontSize: p2r(32),
      ...rFS({ sm: 40, md: 44, lg: 48 }),
    },
    h3: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: p2r(24),
      ...rFS({ sm: 26, md: 30, lg: 32 }),
    },
    h4: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: p2r(20),
      ...rFS({ sm: 20, md: 24, lg: 24 }),
    },
    h5: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: p2r(18),
      ...rFS({ sm: 19, md: 20, lg: 20 }),
    },
    h6: {
      fontWeight: 700,
      lineHeight: 28 / 18,
      fontSize: p2r(17),
      ...rFS({ sm: 18, md: 18, lg: 18 }),
    },
    subtitle1: {
      fontWeight: 600,
      lineHeight: 1.5,
      fontSize: p2r(16),
    },
    subtitle2: {
      fontWeight: 600,
      lineHeight: 22 / 14,
      fontSize: p2r(14),
    },
    body1: {
      lineHeight: 1.5,
      fontSize: p2r(16),
    },
    body2: {
      lineHeight: 22 / 14,
      fontSize: p2r(14),
    },
    caption: {
      lineHeight: 1.5,
      fontSize: p2r(12),
    },
    overline: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: p2r(12),
      textTransform: 'uppercase',
    },
    button: {
      fontWeight: 700,
      lineHeight: 24 / 14,
      fontSize: p2r(14),
      textTransform: 'capitalize',
    },
  } as const;
}
